import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUsersDeleted = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 18,
	viewBox: "0 0 14 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3018_125381)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M6.44383 0.0385812C12.0018 -0.629106 12.5422 7.58625 7.28727 7.90929C2.13957 8.22585 1.55297 0.626319 6.44383 0.0385812Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.441 14.8399C12.6193 15.6556 10.7735 15.507 9.68955 15.5707C9.75866 15.2693 10.0579 15.1564 10.206 14.8723C10.4198 14.4612 10.4416 14.083 10.2294 13.6676C10.052 13.3213 9.18131 12.4824 8.8238 12.3268C7.982 11.96 7.58259 12.4397 6.98347 12.9081C6.4921 12.4187 6.12316 12.0681 5.37278 12.2642C4.97826 12.3674 3.90954 13.3851 3.74412 13.7735C3.59992 14.1117 3.6206 14.3726 3.7463 14.7097C3.8954 15.1083 4.20176 15.2088 4.33399 15.5713C2.92571 15.5 0.574423 15.7458 0.11679 14.0128C-0.524224 11.5878 1.56914 8.82256 4.05592 8.61242C5.5012 8.49034 8.77809 8.45847 10.1809 8.63511C11.8477 8.84525 13.435 10.367 13.8398 11.9595C14.0651 12.8449 14.1462 14.1398 13.441 14.8399Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.65364 13.0808C6.04435 13.0036 6.6402 13.9532 6.98465 14.158C7.18435 14.1925 7.95759 13.0959 8.23674 13.0673C8.55997 13.0338 9.47197 13.9538 9.46055 14.2784C9.44259 14.7814 8.39836 15.3821 8.43645 15.5987C8.68839 15.993 9.54271 16.4317 9.45511 16.9346C9.43552 17.048 8.61983 17.9021 8.50773 17.9539C7.93365 18.2176 7.45643 17.1793 6.98465 16.9832C6.61081 17.2279 6.12815 18.0663 5.6395 17.9961C5.52958 17.9804 4.66437 17.1647 4.61322 17.0545C4.33407 16.4522 5.39952 16.0287 5.58998 15.5425C5.29069 15.1098 4.40427 14.6641 4.5871 14.0634C4.62955 13.9241 5.4904 13.1138 5.65419 13.0813L5.65364 13.0808Z",
				fill: "currentColor"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3018_125381",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 14,
			height: 18,
			fill: "currentColor"
		})
	}) })]
});
export default SvgUsersDeleted;
